module.exports = __webpack_public_path__ + "static/media/logo.5d5d9eef.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/logo.svg
 ** module id = 686
 ** module chunks = 0
 **/